const DSPREFIX = 'FS.ds.'

export const getSessionStorageItem = (cacheableKey) => {
  let sessionValue
  const dsKey = `${DSPREFIX}${cacheableKey}`
  try {
    sessionValue = JSON.parse(sessionStorage.getItem(dsKey))
  } catch (e) {
    sessionValue = sessionStorage.getItem(dsKey)
  }

  return sessionValue
}

export const setSessionStorageItem = (cacheableData) => {
  Object.keys(cacheableData).forEach((key) => {
    const sessionValue = JSON.stringify(cacheableData[key])
    sessionStorage.setItem(`${DSPREFIX}${key}`, sessionValue)
  })
}

export const removeSessionStorageItem = (key) => {
  sessionStorage.removeItem(`${DSPREFIX}${key}`)
}
